<a
    class="flex flex-col items-center justify-center p-2 rounded-lg cursor"
    routerLink="/dashboard"
    routerLinkActive=""
    (mouseenter)="isHovered = true"
    (mouseleave)="isHovered = false"
    #link="routerLinkActive">
    <fa-icon
        class="text-[22px] text-bluegrey"
        [icon]="faHome"
        [ngClass]="{ hidden: isHovered || link.isActive }" />
    <fa-icon
        class="text-[22px] text-blurple"
        [icon]="faHomeSolid"
        [ngClass]="{ hidden: !isHovered && !link.isActive }" />
</a>
